import React, { useEffect, useRef, useState } from "react";
import Loader from "../../../../../components/loader/loader";
// import Snackbar from "../../../../../../components/snackbar/snackbar";
import Snackbar from "../../../../../components/snackbar/snackbar";
import {
  create_accademic_institution,
  update_academy_registration,
  user_institutions_detail,
} from "../../../user.api";
import {
  builtup,
  euip,
  jointVenture,
  landon,
  ownland,
} from "./components/areadata";

import BasicDetails from "./components/basicDetails";
import View from "./components/viewDetails";
import "./style.css";
import jwtDecode from "jwt-decode";
import moment from "moment";
export default function NewCompanyRequest(props) {
  const [activeStep, setActiveStep] = useState(0);

  const [basicData, setBasicData] = useState({});

  const [addCount, setCount] = useState(1);
  const myRef = useRef(null);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [areamange, setareaManage] = useState(builtup);
  // const getDomainTypes = () => {
  //   user_company_domain_list().then((res) => {
  //     setDomain(res.data);
  //     setCount(addCount + 1);
  //   });
  // };
  const getFileNmae = (url) => {
    let name = null;

    name = url.substring(url.lastIndexOf("/") + 1);
    return name;
  };
  const action = (id, data, key) => {
    myRef.current.scrollIntoView();
    if (id === 0) {
      setActiveStep(1);
      setBasicData({ ...data });
    } else if (id === 1) {
      setActiveStep(0);
    } else if (id === 2) {
      handleSubmit();
    }
  };
  const fetchError = (error) => {
    console.log(error.response.data);
    let errmsg = "";
    let errArry = [];

    if (error?.response?.data?.message) {
      errmsg = error.response.data;
    }
    if (error.response.data.error) {
      Object.keys(error.response.data.error).forEach((key) => {
        let err = String(error.response.data.error[key]);
        errArry.push(err);
      });
      errmsg = String(errArry);
    }

    return errmsg;
  };
  let userData = jwtDecode(props.state.payload);
  console.log(userData);
  useEffect(() => {
    user_institutions_detail(userData?.user?.institution_id).then((res) => {
      // let mobile_number= res?.phone_no,
      let Data = res?.data;

      setBasicData({
        ...Data,
        phone_number: Data.phone_no,
        file_registration_proof: Data?.file_registration_proof,
        course_details: Data.courses,
        file_name_proof: Data?.file_registration_proof
          ? getFileNmae(Data?.file_registration_proof)
          : null,
        file_submitted_record: Data?.file_submitted_record,
        file_name_request: Data?.file_submitted_record
          ? getFileNmae(Data?.file_submitted_record)
          : null,
        registration_date: Data.registration_date
          ? moment(Data.registration_date, "YYYY-MM-DD").format("DD-MM-YYYY")
          : null,
      });
      setCount(addCount + 1);
    });
  }, []);
  const handleSubmit = () => {
    let areatype = [];
    if (basicData.area_management) {
      basicData?.area_management?.forEach((item, index) => {
        if (item.location_id) {
          areatype[index] = item;
        }
      });
    }
    const form = new FormData();

    form.append("institution_name", basicData.institution_name ?? null);
    form.append("phone_number", basicData.phone_number);
    form.append("email", basicData.email);
    form.append("address", basicData.address ?? null);
    form.append("registration_date", basicData.registration_date ?? null);
    form.append("affiliation" , basicData?.affiliation ?? null);
    form.append("upload_proposal", basicData.upload_proposal ?? null);
    form.append("total_students", basicData.total_students ?? null);
    form.append("headquaters_detail", basicData.headquaters_detail ?? "");
    if (
      basicData.country_code &&
      basicData.country_code !== "" &&
      basicData.alternate_phone &&
      basicData.alternate_phone !== ""
    ) {
      form.append("country_code", basicData.country_code);
    }
    form.append("alternate_phone", basicData.alternate_phone ?? "");
    form.append(
      "abstract_project_proposal",
      basicData.abstract_project_proposal ?? null
    );
    form.append(
      "contact_person_details",
      basicData.contact_person_details ?? ""
    );
    form.append("notes_institutions", basicData.notes_institutions ?? null);
    form.append(
      "file_submitted_record",
      basicData.file_submitted_record ?? null
    );
    form.append(
      "file_registration_proof",
      basicData.file_registration_proof ?? null
    );

    basicData.course_details.forEach((item, index) => {
      form.append(`course_details[${index}][course_name]`, item.course_name );
    });
    basicData.course_details.forEach((item, index) => {
      form.append( `course_details[${index}][course_type]`, item.course_type);
    });

    setIsActive(true);
    update_academy_registration(userData?.user?.institution_id, form)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setIsActive(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(
          typeof fetchError(error) === "string"
            ? fetchError(error)
            : "Something went wrong"
        );
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const headlperText = {
    header: "",
  };

  // useEffect(() => {
  //   if (domainData.length === 0) {
  //     getDomainTypes();
  //   }
  //   // handleChangedata("3");
  // }, []);

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/dashboard");
      // props.logout();
    }
  };

  return (
    <div className="page-bg" ref={myRef}>
      <Loader open={isActive} />
      <div>
        <div className="dash-banner ">
          <div className="tit-txt">Update - Academic Institution</div>
        </div>
      </div>
      <div className="formbg form-bg">
        <div className="container form-section">
          <div className="mb-3 d-flex justify-content-start">
            <button
              type="button"
              className="btn btn-light border"
              style={{
                borderRadius: "6px",
                padding: "8px 20px",
                fontWeight: "bold",
                fontSize: "14px",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px"
              }}
              onClick={() => props.history.push("/dashboard")}
            >
              <i className="fa fa-arrow-left"></i> Back to Dashboard
            </button>
          </div>
          <div className="itemc">
            <div className="fomy form-inner-section">
              {activeStep === 0 && (
                <BasicDetails
                  {...props}
                  action={action}
                  formData={basicData}
                  update={true}
                />
              )}

              {activeStep === 1 && (
                <View {...props} basicData={basicData} action={action} update={true}/>
              )}
            </div>
            <Snackbar
              message={snackMessage}
              error={isSnackError}
              open={snackOpen}
              close={snackbarClose}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
